import { render } from "./DeFi.vue?vue&type=template&id=012f0b41&scoped=true"
import script from "./DeFi.vue?vue&type=script&lang=js"
export * from "./DeFi.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-012f0b41"

export default script